module.exports = __webpack_public_path__ + "static/media/sso-badge.21a7c746.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/sso-badge.png
// module id = 13905
// module chunks = 0